import { TPS_BASE, IS_DEV, POSROI_BASE } from "../utils/apiConfig";

export const USE_MOCK_API = process.env.REACT_APP_USE_MOCK_API === "true";

export const API_ENDPOINTS = {
  // Lines
  LINES_FIND: (q: string, tpid: string, onlyProper = true) =>
    `${TPS_BASE}/Lines/Find?q=${encodeURIComponent(
      q
    )}&onlyProperLines=${onlyProper}&timeTablePeriod=${encodeURIComponent(
      tpid
    )}`,

  LINES_SEARCH: (q: string, onlyProper = true) =>
    `${TPS_BASE}/Lines?onlyProperLines=${onlyProper}&query=${encodeURIComponent(
      q
    )}`,

  LINES_DETAILS: (lineIdsCsv: string) =>
    `${TPS_BASE}/Lines/LinesDetails?lineIds=${encodeURIComponent(lineIdsCsv)}`,

  LINES_GET_BY_TRAFFIC_TYPE: (trafficTypeKey: string, tpid?: string) =>
    `${TPS_BASE}/Lines/GetByTrafficType?trafficTypeKey=${encodeURIComponent(
      trafficTypeKey
    )}${tpid ? `&timeTablePeriod=${encodeURIComponent(tpid)}` : ""}`,

  // PosRoi (live traffic)
  POSROI_GET: (query: string) => `${POSROI_BASE}/get?${query}`,

  // Geo/WFS
  GEO_FETCH: `${TPS_BASE}/Geo/fetch`,

  GEO_TIMETABLE_PERIODS: IS_DEV
    ? "/api/v1/Geo/TimetablePeriods"
    : `${TPS_BASE}/Geo/TimetablePeriods`,

  POINTS_FIND: IS_DEV ? "/api/v1/Points/Find" : `${TPS_BASE}/Points/Find`,

  // Query builders
  getTravelDetails: (referenceId: string, editId: string) =>
    `${TPS_BASE}/GroupTravel/GetDetails?referenceId=${encodeURIComponent(
      referenceId
    )}&editId=${encodeURIComponent(editId)}`,
};
